// extracted by mini-css-extract-plugin
module.exports = {"Bio":"Bio_Bio__1ks_2","logo":"Bio_logo__2BmsZ","copy":"Bio_copy__28Poj"};